import { useStanQuery } from '@/queries';
import { appointmentsApi } from '@/lib/api/appointments';
import { getLocalTimezone } from '@/lib';
import type { Booking } from '../types/appointment.types';

interface UseBookingParams {
    bookingId: string;
    timezone?: string;
}

/**
 * Query for fetching a single booking by ID
 */
export function useBookingQuery({ bookingId, timezone = getLocalTimezone() }: UseBookingParams) {
    return useStanQuery<Booking>({
        queryKey: ['booking', bookingId, timezone],
        queryFn: async () => {
            const response = await appointmentsApi.getBookingById(bookingId, timezone);
            const booking = response.data[0];
            if (!booking) {
                throw new Error('Booking not found');
            }
            return booking;
        },
        enabled: !!bookingId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
        meta: { error: { sentryMessage: '[APPOINTMENTS] failed-to-fetch-booking' } },
    });
}
